import styled from "styled-components";
import { PALETTE } from "../commons/Commons.style";
import { BREAKPOINTS } from "../grid";

export const SectionBottomStyle = styled.div`
  padding-top: 60px;
  border-bottom: thin solid ${PALETTE.BLACK};

  @media only screen and (max-width: ${BREAKPOINTS.MD}px) {
    padding-top: 24px;
  }
`;

export const SectionContainerStyle = styled.section`
  padding: 6px 0 0;

  @media only screen and (max-width: ${BREAKPOINTS.LG}px) {
    padding: 6px 0 0;
  }

  @media only screen and (max-width: ${BREAKPOINTS.MD}px) {
    padding-top: 16px;
  }

  &:last-child ${SectionBottomStyle} {
    border-bottom: none;
  }
`;
